import React from 'react';

interface EmptyProps {
  className?: string;
  title?: string;
  message?: string;
}

const Empty: React.FC<EmptyProps> = ({
  className = '',
  title = "Sorry, we couldn't find anything",
  message = 'Try searching for something else or adjusting your filters',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center pointer-events-none ${className}`}
    >
      <div className="flex justify-center w-full">
        <div className="md:w-[356px] w-[256px]">
          <img
            src="/animations/searching-cat.svg"
            alt=""
            className="h-full w-full"
          />
        </div>
      </div>
      <div className="text-center w-full px-4">
        <h3 className="text-lg font-medium text-foreground">{title}</h3>
        <p className="mt-2 text-gray-500">{message}</p>
      </div>
    </div>
  );
};

export default Empty;
